import Loadable from 'react-loadable';

const HomeLoadable = Loadable({
  loader: () => import(/* webpackChunkName: 'home' */ './Home.js').then(module => module.default),
  loading: () => null,
});

export default HomeLoadable;
